"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Voice = exports.Meta = exports.Genre = exports.Composer = void 0;
var Composer_1 = require("./Composer");
Object.defineProperty(exports, "Composer", { enumerable: true, get: function () { return Composer_1.Composer; } });
var Genre_1 = require("./Genre");
Object.defineProperty(exports, "Genre", { enumerable: true, get: function () { return Genre_1.Genre; } });
var Meta_1 = require("./Meta");
Object.defineProperty(exports, "Meta", { enumerable: true, get: function () { return Meta_1.Meta; } });
var Voice_1 = require("./Voice");
Object.defineProperty(exports, "Voice", { enumerable: true, get: function () { return Voice_1.Voice; } });
//# sourceMappingURL=notearchive.js.map